module.exports = __webpack_public_path__ + "img/img5.8eab956e.svg";